import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { IAuthorizedTask } from '../IAuthorizedTask';

export const getAuthorizedTasks = createAction(
  '[TimeCard/API] Get Authorized Tasks',
  props<{ EmployeeListID: string, AuthType: string, AsOfDate: Date }>()
);

//////////////////////////////////////////////////////////

export const loadAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Load AuthorizedTasks',
  props<{ authorizedTasks: IAuthorizedTask[] }>()
);

export const addAuthorizedTask = createAction(
  '[IAuthorizedTask/API] Add AuthorizedTask',
  props<{ authorizedTask: IAuthorizedTask }>()
);

export const upsertAuthorizedTask = createAction(
  '[IAuthorizedTask/API] Upsert AuthorizedTask',
  props<{ authorizedTask: IAuthorizedTask }>()
);

export const addAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Add AuthorizedTasks',
  props<{ authorizedTasks: IAuthorizedTask[] }>()
);

export const upsertAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Upsert AuthorizedTasks',
  props<{ authorizedTasks: IAuthorizedTask[] }>()
);

export const updateAuthorizedTask = createAction(
  '[IAuthorizedTask/API] Update AuthorizedTask',
  props<{ authorizedTask: Update<IAuthorizedTask> }>()
);

export const updateAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Update AuthorizedTasks',
  props<{ authorizedTasks: Update<IAuthorizedTask>[] }>()
);

export const deleteAuthorizedTask = createAction(
  '[IAuthorizedTask/API] Delete AuthorizedTask',
  props<{ id: string }>()
);

export const deleteAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Delete AuthorizedTasks',
  props<{ ids: string[] }>()
);

export const clearAuthorizedTasks = createAction(
  '[IAuthorizedTask/API] Clear AuthorizedTasks'
);
